/**
 * Line item quantity dropdown (cart drawer / cart page).
 *
 * The theme's built-in `is="quantity-input"` behavior only applies to native
 * <input> elements, so the quantity <select> dropdowns added on line items
 * are wired up here instead. On change, the new quantity is sent to
 * Shopify's cart endpoint and the theme is asked to refresh its own UI
 * (drawer, cart count, totals, free shipping bar...) via the documented
 * "cart:refresh" event, keeping the rest of the theme's cart logic intact.
 *
 * https://support.maestrooo.com/article/764-javascript-events-exposed-by-the-theme
 */
(function () {
  var SELECTOR = '.line-item-quantity-select';

  document.addEventListener('change', function (event) {
    var select = event.target.closest ? event.target.closest(SELECTOR) : null;

    if (!select) {
      return;
    }

    var lineKey = select.dataset.lineKey;
    var quantity = parseInt(select.value, 10);

    if (!lineKey || Number.isNaN(quantity)) {
      return;
    }

    select.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to update the cart');
        }

        return response.json();
      })
      .then(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        select.disabled = false;
      });
  });
})();
